
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "ShoppingListSearchResultItem",
  props: {
    /** id */
    id: {
      type: Number,
      required: false
    },
    /** 画像 */
    imageUrl: {
      type: String,
      required: false
    },
    /** 食材名 */
    ingredientName: {
      type: String,
      required: true
    },
    /** 検索文字列表示 */
    isRawSearchString: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("ShoppingListSearchResultItem setup start");
    NativeClient.sendDebugLog("ShoppingListSearchResultItem setup name = " + props.ingredientName);

    const selectItem = () => {
      if (props.isRawSearchString || props.id == undefined || props.id == null) {
        NativeClient.sendDebugLog("ShoppingListSearchResultItem selectItem id = null, name = " + props.ingredientName);
        context.emit("select-item", null, props.ingredientName);
      } else {
        NativeClient.sendDebugLog("ShoppingListSearchResultItem selectItem id = " + props.id + ", name = " + props.ingredientName);
        context.emit("select-item", props.id, props.ingredientName);
      }
    };

    const isNotRaw = computed(() => {
      return !props.isRawSearchString;
    });

    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("ShoppingListSearchResultItem onImageError");
      if (event.target) {
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };

    return {
      selectItem,
      isNotRaw,
      onImageError
    };
}
});
